<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUngdommerStore } from '@/modules/ungdommer/store/UngdommerStore'
import { onMounted } from 'vue'

const { hurtigvalgte } = storeToRefs(useUngdommerStore())
const { hentHurtigvalg } = useUngdommerStore()

onMounted(() => {
  hentHurtigvalg()
})
</script>

<template>
  <v-list v-if="hurtigvalgte.length > 0">
    <v-list-item v-for="item in hurtigvalgte" :key="item.id" :value="item.ungdom_navn" class="py-3">
      <v-list-item-title>
        <template #default="">
          <RouterLink
            title="Se opplysninger"
            :to="{
              name: 'Ungdom',
              params: { id: item.ungdom_id },
              state: { liste: JSON.stringify([item.ungdom_id]) }
            }"
            >{{ item.ungdom_navn }}</RouterLink
          ></template
        >
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<style scoped lang="scss"></style>
